import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    vendors: [],
    summary: {
      totalPurchase: 0,
      pendingAmount: 0,
      count: 0
    },
    filters: {
      timeRange: "Total Data",
      customFromDate: "",
      customToDate: "",
      visitCount: 0
    }
  },
  loading: false,
  error: null,
};

const supplierReportSlice = createSlice({
  name: "supplierReport",
  initialState,
  reducers: {
    supplierReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    supplierReportSuccess(state, action) {
      state.loading = false;
      state.data = {
        ...action.payload.data,
        filters: {
          ...state.data.filters,
          ...action.payload.data.filters
        }
      };
    },
    supplierReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSupplierReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateSupplierReportFilters(state, action) {
      state.data.filters = {
        ...state.data.filters,
        ...action.payload
      };
    }
  },
});

export const {
  supplierReportRequest,
  supplierReportSuccess,
  supplierReportFailure,
  resetSupplierReport,
  updateSupplierReportFilters
} = supplierReportSlice.actions;

export default supplierReportSlice.reducer;